const formatCurrency = function(value, currency) {
  if (typeof value !== 'number' || !currency) {
    return value;
  }

  return new Intl.NumberFormat('ru-RU', {
    currency,
    style: 'currency',
    minimumFractionDigits: 0,
  }).format(value);
};

const formatPercent = function(value, accuracy = 1) {
  if (typeof value !== 'number' || !accuracy) {
    return value;
  }

  return new Intl.NumberFormat('ru-RU', {
    style: 'percent',
    maximumFractionDigits: 1,
  }).format(value / accuracy);
};

const formatMoney = function(value) {
  if (typeof value !== 'number') {
    return value;
  }

  return new Intl.NumberFormat('ru-RU', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(value);
};

const formatMonthYear = function(date) {
  if (!(date instanceof Date) && typeof date !== 'number') {
    return date;
  }

  const month = new Intl.DateTimeFormat('ru-RU', {
    month: 'long',
  }).format(date);

  return `${month} ${date.getFullYear()}`;
};

const formatDateTime = function(date) {
  if (!(date instanceof Date) && typeof date !== 'number') {
    return date;
  }

  return new Intl.DateTimeFormat('ru-RU', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  }).format(date);
};

const formatDate = function(date) {
  if (!(date instanceof Date) && typeof date !== 'string') {
    return date;
  }
  const v = new Date(date);
  return `${v.getDate()}.${v.getMonth() + 1}.${v.getFullYear()}`;
};

export { formatCurrency, formatPercent, formatMoney, formatMonthYear, formatDateTime, formatDate };
